import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this.loading.asObservable();
  private timeoutTimer: any = null;

  constructor() {}

  show(): any {
    this.loading.next(true);
    if (this.timeoutTimer) {
      clearTimeout(this.timeoutTimer);
    }
    // Fail-safe safety guard: automatically self-terminate after 3 seconds max
    this.timeoutTimer = setTimeout(() => {
      this.hide();
    }, 3000);
  }

  hide(): any {
    if (this.timeoutTimer) {
      clearTimeout(this.timeoutTimer);
      this.timeoutTimer = null;
    }
    this.loading.next(false);
  }
}
